import Skeleton from './Skeleton'

export * from './Skeleton'

export default Skeleton
